import maplibregl from 'maplibre-gl';
import { basemapTiles } from '../data/constants.js';

export function createMap() {
  const map = new maplibregl.Map({
    container: 'map',
    style: {
      version: 8,
      sources: {
        carto: {
          type: 'raster',
          tiles: [basemapTiles.light],
          tileSize: 256,
          attribution: '© OpenStreetMap © CARTO'
        }
      },
      layers: [{ id: 'carto', type: 'raster', source: 'carto' }]
    },
    center: [-1.1, 7.6],
    zoom: 6.3,
    minZoom: 1,
    // Wider extent than just Ghana so users can pan to neighbouring countries
    // and zoom out to a continental view. Still loose enough to keep focus.
    maxBounds: [[-25, -10], [25, 25]],
    // Required for `canvas.toDataURL()` to return non-blank pixels in the
    // PNG export. Without this, WebGL clears the buffer after each draw
    // and the canvas exports as transparent.
    preserveDrawingBuffer: true,
  });

  map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'bottom-right');
  map.addControl(new maplibregl.ScaleControl({ maxWidth: 120 }), 'bottom-left');

  map.on('mousemove', e => {
    const { lat, lng } = e.lngLat;
    document.getElementById('coords').textContent =
      `${lat.toFixed(4)}°N ${Math.abs(lng).toFixed(4)}°${lng < 0 ? 'W' : 'E'}`;
  });
  map.on('zoom', () => {
    document.getElementById('zoom-level').textContent = `z${map.getZoom().toFixed(1)}`;
  });

  return map;
}
